import { Injectable } from '@angular/core';

import { ActivationResponseModel } from './typings/my-workshop.activation-response';
import { ApiService }              from '../api/api.service';
import { CodeTypeModel }           from '../core/models/code-type';
import { EditorTokenModel }        from './typings/my-workshop.editor-token';
import { MyWorkshopStatusModel }   from './typings/my-workshop.status';

@Injectable({
  providedIn: 'root'
})
export class MyWorkshopService {
  constructor (
    private apiService : ApiService
  ) {}

  activate ( type : string ) : Promise<ActivationResponseModel> {
    return this.apiService.post('/mws/activate', {
      workshop_type: type
    });
  }

  getEditorToken () : Promise<EditorTokenModel> {
    return this.apiService.get('/mws/edit');
  }

  getStatus () : Promise<MyWorkshopStatusModel> {
    return this.apiService.get('/mws/status');
  }

  getWorkshopTypes () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/mws/mws_ws_types');
  }

  isEnrichmentDone ( event : MessageEvent ) : boolean {
    return event.data?.type === 'mws_enrichment_done';
  }
}
